<form id="order-info-form-pg-1" [formGroup]="formGroup">

    <!-- Code Implementation for Order Information -->

    <p-panel header="Order Information" styleClass="mb-5 panel-skew-heading">

        <div class="row mb-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-ref-num" class="form-label required-asterisk">Claim Number</label>
                <input pInputText type="text" id="order-info-ref-num" placeholder="Enter claim number"
                    class="form-control" formControlName="orderInfoRefNum"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoRefNum')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoRefNum')" class="error-label">This field
                    is mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label class="form-label required-asterisk">Date of Incident</label>
                <p-datepicker id="date-of-incident-date-picker" placeholder="mm/dd/yyyy" formControlName="orderInfoDate"
                    showIcon iconDisplay="input" styleClass="w-100" [maxDate]="maxDate"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoDate')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoDate')" class="error-label">This field is
                    mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-tenant-name" class="form-label">Carrier Name</label>
                <input pInputText type="text" id="order-info-tenant-name" placeholder="{{ tenantName }}"
                    class="form-control" formControlName="orderInfoTenantName" />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-12">
                <label class="form-label mb-3 required-asterisk"><strong>Type of Order</strong></label>
                <div *ngFor="let category of categories" class="d-flex mb-2 ms-3">
                    <p-radiobutton [inputId]="category.name" [value]="category" formControlName="selectedCategory"
                        [ngClass]="{'ng-invalid ng-dirty' : isError('selectedCategory')}" />
                    <label [for]="category.name" class="ms-2 pointer">
                        {{ category.description }}
                        <!-- <br />{{ category.description }} -->
                    </label>
                </div>
                <small id="order-info-ref-num-error" *ngIf="isError('selectedCategory')" class="error-label">This field
                    is mandatory</small>
            </div>
        </div>
        <!-- <div class="row mb-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label class="form-label required-asterisk">Service Level</label><br />
                <p-select formControlName="selectedLevel" [options]="levels" optionLabel="name"
                    placeholder="Select service level" styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('selectedLevel')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('selectedLevel')" class="error-label">This field is
                    mandatory</small>
            </div>
        </div> -->
        <div class="row mb-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label class="form-label">Special Handling</label><br />
                <p-checkbox formControlName="selectedLevel" id="order-info-special-handling" [binary]="true" />
                <label for="order-info-special-handling" class="ms-2">Rush order</label>
            </div>
        </div>
    </p-panel>

    <!-- Code Implementation for Contact Information -->

    <p-panel header="Contact Information" styleClass="mb-5 panel-skew-heading">
        <div formArrayName="contacts">
            <div *ngFor="let contact of contacts.controls; let i = index" [formGroupName]="i"
                [ngClass]="{'mt-2rem': i > 0}">
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                            <h2 class="contactListNo">
                                <span *ngIf="i<9">Contact {{ '0'+ (i + 1) }}</span>
                                <span *ngIf="i>=9">Contact {{ i + 1 }}</span>
                            </h2>
                            <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true" label="Delete" *ngIf="i>0"
                                (onClick)="showContactDeletionModal(i)"></p-button>
                        </div>
                        <!--  <hr /> -->
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="order-info-contact-{{i}}" class="form-label d-block required-asterisk">Contact
                            Name</label>
                        <input pInputText type="text" id="order-info-contact-{{i}}" class="w-100"
                            placeholder="Enter name" formControlName="contactName"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactName', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactName', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                    <div class="col-8 col-md-2 col-lg-2  mb-3 mb-sm-0 pe-1">
                        <label for="order-info-contact-phone-{{i}}"
                            class="form-label d-block required-asterisk">Phone</label>
                        <input pInputText type="text" id="order-info-contact-phone-{{i}}" placeholder="Enter phone"
                            formControlName="contactPhone" class="w-100"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactPhone', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactPhone', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                    <div class="col-4 col-md-1 col-lg-1  mb-3 mb-sm-0 ps-1">
                        <label for="order-info-contact-phone-extn-{{i}}" class="form-label d-block">Extension</label>
                        <input pInputText type="text" id="order-info-contact-phone-extn-{{i}}" placeholder="Enter"
                            formControlName="contactPhoneExtn" class="w-100" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="order-info-contact-email-{{i}}"
                            class="form-label d-block required-asterisk">Email</label>
                        <input pInputText type="email" id="order-info-contact-email-{{i}}" class="w-100"
                            placeholder="Enter email" formControlName="contactEmail"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactEmail', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactEmail', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="order-info-contact-title-{{i}}"
                            class="form-label d-block required-asterisk">Title</label>
                        <p-select formControlName="contactTitle" id="order-info-contact-title-{{i}}" [options]="titles"
                            optionLabel="title" placeholder="Select title"
                            (onChange)="onTitleSelection($event.value.value, i)" styleClass="w-100"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactTitle', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactTitle', contact)"
                            class="error-label">This
                            field is mandatory</small>
                        <!-- {{contact?.get('contactTitle')?.value.value}} -->
                    </div>
                </div>
                <div class="row mb-3"
                    *ngIf="formGroup?.get('selectedCategory')?.value?.name == 'subpoena-to-be-prepared' && contact?.get('contactTitle')?.value?.value == 'attorney'">
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="order-info-contact-bar-no-{{i}}" class="form-label d-block required-asterisk">Bar
                            Number</label>
                        <input pInputText type="text" id="order-info-contact-bar-no-{{i}}"
                            placeholder="Enter attorney's bar number" formControlName="contactBarNo" class="w-100"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('contactBarNo', contact)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('contactBarNo', contact)"
                            class="error-label">This
                            field is mandatory</small>
                    </div>
                </div>
            </div>
        </div>
        <p-button aria-label="Add New Contact" label="Add New Contact" styleClass="px-0" icon="pi pi-plus"
            (onClick)="addNewContact()" [link]="true" />
        <!-- Contact Div Appended Here on Add Button -->
    </p-panel>

    <!-- Code Implementation for Billing Information -->

    <p-panel header="Billing Information" styleClass="mb-5 panel-skew-heading">
        <div class="row mb-3">
            <!-- <div class="col-sm-3 mb-3 mb-sm-0">
                <label class="form-label d-block">Title</label>
                <p-select formControlName="orderInfoSelectedBillTo" [options]="billers" optionLabel="name"
                    placeholder="{{ billers[0].name }}" styleClass="w-100" />
            </div> -->
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-bill-to-email" class="form-label d-block required-asterisk">Email</label>
                <input pInputText type="email" id="order-info-bill-to-email" class="form-control"
                    formControlName="orderInfoBillToEmail" placeholder="Enter email"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoBillToEmail')}" />
                <small id="order-info-ref-num-error"
                    *ngIf="isError('orderInfoBillToEmail') && formGroup?.get('orderInfoBillToEmail')?.hasError('required')"
                    class="error-label">This field is mandatory</small>
                <small *ngIf="formGroup?.get('orderInfoBillToEmail')?.hasError('email')" class="error-label">Please
                    enter a valid email address.</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-billing-contact-name" class="form-label d-block required-asterisk">Billing
                    Contact Name</label>
                <input pInputText type="text" id="order-info-billing-contact-name"
                    placeholder="Enter billing contact name" class="form-control"
                    formControlName="orderInfoBillingContactName"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoBillingContactName')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoBillingContactName')"
                    class="error-label">This field is mandatory</small>
            </div>
        </div>
    </p-panel>

    <!-- Code Implementation for Delivery Information -->

    <p-panel header="Delivery Information" styleClass="mb-5 panel-skew-heading">
        <div class="row mb-4">
            <div class="col-sm-12">
                <strong>If you need physical copy / CDs then fill in details below</strong>
            </div>
        </div>
        <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-attention-to" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Attention To</label>
                <input pInputText type="text" id="order-info-attention-to" placeholder="Enter attention to"
                    class="form-control" formControlName="orderInfoAttentionTo"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionTo')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionTo')" class="error-label">This
                    field is mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-attention-to-firm-name" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Firm Name</label>
                <input pInputText type="text" id="order-info-attention-to-firm-name" placeholder="Enter firm name"
                    class="form-control" formControlName="orderInfoAttentionToFirmName"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmName')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmName')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-8 col-md-2 col-lg-2 mb-3 mb-sm-0 pe-1">
                <label for="order-info-attention-to-firm-phone" class="form-label d-block">Phone</label>
                <input pInputText id="order-info-attention-to-firm-phone" placeholder="Enter phone"
                    formControlName="orderInfoAttentionToFirmPhone" class="w-100" />
            </div>
            <div class="col-4 col-md-1 col-lg-1  mb-3 mb-sm-0 ps-1">
                <label for="order-info-attention-to-firm-phone-extension" class="form-label d-block">Extension</label>
                <input pInputText type="number" id="order-info-attention-to-firm-phone-extension" placeholder="Enter"
                    formControlName="orderInfoAttentionToFirmPhoneExtn" class="w-100" />
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-firm-address" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Street Address</label>
                <input pInputText type="text" id="order-info-firm-address" placeholder="Enter street address"
                    class="form-control" formControlName="orderInfoAttentionToFirmAddress"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmAddress')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmAddress')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-attention-to-firm-city" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">City</label>
                <input pInputText type="text" id="order-info-attention-to-firm-city" placeholder="Enter city"
                    class="form-control" formControlName="orderInfoAttentionToFirmCity"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmCity')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmCity')"
                    class="error-label">This field is mandatory</small>

            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-attention-to-firm-state" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">State</label>
                <p-select formControlName="orderInfoAttentionToFirmState" [options]="states" optionLabel="name"
                    placeholder="Select state" styleClass="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmState')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmState')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-attention-to-firm-zip" class="form-label d-block"
                    [ngClass]="{'required-asterisk': isAttentionToOrFirmNameFilled()}">Zip</label>
                <input pInputText type="text" id="order-info-attention-to-firm-zip" placeholder="Enter zip"
                    formControlName="orderInfoAttentionToFirmZip" class="w-100"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttentionToFirmZip')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('orderInfoAttentionToFirmZip')"
                    class="error-label">This field is mandatory</small>
            </div>
        </div>
    </p-panel>

    <!-- Code Implementation for Attachments -->

    <p-panel header="Attachments" styleClass="mb-5 panel-skew-heading">
        <app-loader></app-loader>
        <div class="row mb-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-attachment-document" class="form-label d-block">Document</label>
                <p-fileupload #fileUpload mode="basic" chooseLabel="Choose File" chooseIcon="pi pi-upload"
                    name="recordFile[]" url="" accept=".pdf,.docx,image/*" maxFileSize="maxFileSize"
                    (onSelect)="onFileSelect($event, fileUpload)"/>
                <small id="order-info-ref-num-error" *ngIf="fileSizeError"
                    class="error-label">Invalid file size, maximum upload size is 100MB.</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="order-info-attachment-label" class="form-label d-block" 
                [ngClass]="{'required-asterisk': isFileUploaded()}">Label</label>
                <p-select formControlName="orderInfoAttachmentLabel" id="order-info-attachment-label"
                    [options]="attachmentLabels" optionLabel="name" placeholder="Select label" styleClass="w-100"
                    (onChange)="onLabelChange($event)" 
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttachmentLabel')}" />
                <small id="order-info-attachment-label-error" *ngIf="isError('orderInfoAttachmentLabel')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0" *ngIf="showDescription">
                <label for="order-info-attachment-explain-other"
                    class="form-label d-block required-asterisk">Description</label>
                <input pInputText type="text" id="order-info-attachment-explain-other" placeholder="Enter description"
                    class="form-control" formControlName="orderInfoAttachmentExplanation"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('orderInfoAttachmentLabel')}"  (input)="onDescriptionChange()" />
                <small id="order-info-attachment-label-error" *ngIf="isError('orderInfoAttachmentExplanation')"
                    class="error-label">This field is mandatory</small>
            </div>
            <div class="col-sm-3 mt-4">
                <p-button id="order-info-attachment-upload" aria-label="Upload" [disabled]="isUploadDisabled" label="Upload" (onClick)="uploadFile($event)" />
                <p-button id="order-info-attachment-cancel" aria-label="Cancel" label="Cancel" severity="secondary" (onClick)="cancelUpload(fileUpload)"
                    styleClass="ms-3" />
            </div>
        </div>
        <div class="row mb-3 mt-5">
            <div class="col-sm-9">
                <p-table [value]="attachments" [rows]="5" styleClass="table-light-header">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pResizableColumn style="width: 30%;"  scope="col">Label</th>
                            <th pResizableColumn  scope="col">Uploaded Files</th>
                            <th pResizableColumn style="width: 5%;"  scope="col">Actions</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-attachment>
                        <tr>
                            <td data-label="Label">{{ attachment.description }}</td>
                            <td data-label="Uploaded Files">
                                <p-button aria-label="Uploaded Files" styleClass="px-0"
                                    label="{{ attachment.filename }}" (onClick)="downloadFile(attachment.fileId)"
                                    [link]="true" />
                            </td>
                            <td data-label="Actions">
                                <p-button aria-label="Actions" styleClass="px-0" [link]="true" icon="pi pi-trash"
                                    [text]="true" (onClick)="showFileDeletionModal(attachment.fileId)" class="me-2" label="Delete" />
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" class="p-3 empty-message">No files uploaded!</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </p-panel>

    <!-- Code Implementation for Special Instructions -->

    <p-panel header="Special Instructions" styleClass="panel-skew-heading">
        <div class="row mb-0">
            <div class="col-sm-12">
                <textarea class="w-100" pTextarea id="order-info-special-instructions" placeholder="Enter text here"
                    formControlName="orderInfoSpecialInstructions"></textarea>
            </div>
        </div>
    </p-panel>

    <!-- Code Implementation for Next Step Button -->

    <!-- <div class="row mb-3">
        <div class="col-sm-12 text-end">
            <hr/>
            <p-button label="Next Step" />
        </div>
    </div> -->

</form>
<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'" [acceptLabel]="'Yes'"
    (acceptModalClick)="confirmContactDeletion()" (rejectModalClick)="showDeleteModal = false">
    <span>Are you sure want to delete this?</span>
</app-modal>
<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showFileDeleteModal" [rejectLabel]="'No'"
    [acceptLabel]="'Yes'" (acceptModalClick)="  confirmFileDeletion()" (rejectModalClick)="showFileDeleteModal = false">
    <span>Are you sure want to delete this file?</span>
</app-modal>